import Filter from "./Filter";

const modalTypes = {
  Filter,
};
export default modalTypes;
